/**
 * Global payment providers' connect cards (Payments Hub wave 4). Spread into
 * enIntegrationTiles; t() and MessageKey are unchanged.
 * TODO(copy-GO): every string here waits on Marketing approval.
 */
export const enPaymentProviders = {
  'paymentProviders.paddle.name': 'Paddle',
  'paymentProviders.lemonsqueezy.name': 'Lemon Squeezy',
  'paymentProviders.gumroad.name': 'Gumroad',
  'paymentProviders.square.name': 'Square',
  'paymentProviders.mollie.name': 'Mollie',
  'paymentProviders.razorpay.name': 'Razorpay',
  'paymentProviders.chargebee.name': 'Chargebee',
  'paymentProviders.recurly.name': 'Recurly',
  'paymentProviders.description': 'Read-only: what you sell, your sales, refunds and subscriptions. Money never moves through BuzzBit X.',
  'paymentProviders.howTo': 'Paste an API key — read access is all BuzzBit X uses, and where the provider offers read-only keys, use one. Nothing is charged, refunded or changed at the provider. Your keys are encrypted and never shown again.',
  'paymentProviders.docs': 'How to create the key and the webhook',
  'paymentProviders.connect': 'Connect',
  'paymentProviders.connected': 'Connected. Add the webhook below at the provider.',
  'paymentProviders.failed': 'Could not connect. Check the key and try again.',
  'paymentProviders.loadFailed': 'Could not load the setup for this provider. Try again in a minute.',
  'paymentProviders.webhookUrl': 'Webhook URL to add at the provider',
  'paymentProviders.mintedSecret': 'Signing secret to type into the provider',
  'paymentProviders.secretOnce': 'Shown once. Copy it now — it cannot be shown again.',
  'paymentProviders.pasteSecret': 'After adding the webhook, paste the signing secret the provider shows you',
  'paymentProviders.pasteSecretOptional': 'Using Mollie’s next-gen webhooks? Paste their signing secret here. Classic webhooks need none',
  'paymentProviders.webhookUser': 'Basic auth user to enter at the provider',
  'paymentProviders.saveSecret': 'Save secret',
  'paymentProviders.secretSaved': 'Signing secret saved.',
  'paymentProviders.secretFailed': 'Could not save the secret. Check it and try again.',
  'paymentProviders.unsigned': 'This provider does not sign its webhooks, so every event is checked with the provider before it is recorded.',
  'paymentProviders.sync': 'Check and sync now',
  'paymentProviders.syncQueued': 'Checking the key, then syncing your products and history in the background. This connection’s status shows how it went.',
  'paymentProviders.syncFailed': 'Could not start the sync. Try again in a minute.',
  'paymentProviders.field.apiKey': 'API key',
  'paymentProviders.field.accessToken': 'Access token',
  'paymentProviders.field.keyId': 'Key ID',
  'paymentProviders.field.keySecret': 'Key secret',
  'paymentProviders.field.site': 'Site name (e.g. acme or acme-test)',
  'paymentProviders.field.environment': 'Environment',
  'paymentProviders.field.region': 'Region',
  'paymentProviders.field.mode': 'Account mode (live, or test / sandbox)',
} as const;
